module.exports = __webpack_public_path__ + "static/media/tomcat.49e0b7c6.svg";